import React from "react";
import { useAuth } from "./../util/auth.js";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';



function PasswordResetModal(props) {

    const auth = useAuth();

    const [open, setOpen] = React.useState(props.show);

    const handleClickOpen = () => {
        // setOpen(true);
        props.show = true
    };

    const handleClose = () => {
        // setOpen(false);
        props.show = false
    };

    const handlePasswordReset = () => {
        if (auth && auth.user && auth.user.email) {
            auth.sendPasswordResetEmail(auth.user.email);
        }
    };
    
    return (
        <Dialog
            open={props.show}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogContent><h1>Welcome to Sutra!</h1></DialogContent>
            {/* <DialogTitle></DialogTitle> */}
            <DialogTitle id="alert-dialog-title">{"Please reset your temporary password"}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    For security purposes, we require that you update your password. Please complete the following:
                </DialogContentText>
                <DialogContentText id="alert-dialog-description">
                    1) Click the button "UPDATE PASSWORD" below
                </DialogContentText>
                <DialogContentText id="alert-dialog-description">
                    2) Check your email from "Reset your password for Sutra" and click on the embedded link
                </DialogContentText>
                <DialogContentText id="alert-dialog-description">
                    3) Once you update you password, refresh this page
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handlePasswordReset} color="primary">
                    update password
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default PasswordResetModal;
